/* eslint-disable jsx-a11y/href-no-hash */
import React from "react";
import styles from "./styles.css";
import { Segment, Container } from "semantic-ui-react";
import { PRIMARY_COLOR } from "../../constants";

export class TOS extends React.Component {
  state = {};

  render() {
    return (
      <Segment style={{ padding: "4em 0em", margin: 0 }}>
        <Container text>
          <div className={styles.registerForm} style={{ fontSize: "1.33em", textAlign: 'justify' }}>
            <div>
              <h1>Nutzungsbedingungen audory UG (haftungsbeschränkt)</h1>
              <h2>1. Anwendungsbereich</h2>
              <div>
              Die nachfolgenden Nutzungsbedingungen gelten für die Nutzung der Dienste und Angebote der audory UG (haftungsbeschränkt), Technologie-Campus 1, 09126 Chemnitz („<b>audory</b>“) über die Plattformen von audory.io. Diese beinhalten die Editorsoftware zur Produktion und die Applikationen für Endgeräte zum Konsum von interaktiven Hörbüchern/-spielen (insgesamt „<b>audory-Dienste</b>“). 
                <br />
                <br />
                Wir bieten dir als unseren Nutzer dabei die Möglichkeit, interaktive Hörbücher als Audio-Inhalte zu genießen („<b>Hörer</b>“) und über unseren Editor selbst zu erstellen und über audory zu vertreiben („<b>Autor</b>“).
                <br />
                <br />
                Die Einbeziehung der Nutzungsbedingungen in ihrer jeweils aktuellen Fassung ist Voraussetzung für die Nutzung der audory-Dienste. Wir empfehlen daher, die Nutzungsbedingungen sorgfältig zu lesen. 
                <br/>
                <br/>
                Die Bedingungen gelten – soweit nicht abweichend geregelt – auch für zukünftige Updates oder neue Versionen der audory-Dienste.
                <br/>
                <br/>
                Ergänzend zu den Nutzungsbedingungen finden unsere <a style={{color: PRIMARY_COLOR}} href='/cos'>Allgemeinen Verkaufsbedingungen</a> sowie unsere <a style={{color: PRIMARY_COLOR}} href='/privacypolicy'>Datenschutzerklärung</a> Anwendung, auf deren Einbeziehung wir an verschiedenen Stellen hinweisen.

              </div>
              <h2>2. audory-Account</h2>
              <div>
                Um unsere Dienste nutzen zu können, legst du dir zunächst einen eigenen audory-Account an. Du kannst dazu unsere Plattform audory.io oder unsere audory-App nutzen. Egal, ob du Hörer und/oder Autor bist, besitzt du nur einen Account. Mit dem Anlegen des Accounts entstehen für dich keine Kosten.
                <br />
                <br />
                Die Nutzung der audory-Dienste ist nur Personen ab dem vollendeten 16. Lebensjahr gestattet. Bis zur Vollendung des 18. Lebensjahres ist die Erlaubnis eines Erziehungsberechtigten erforderlich, um audory-Dienste zu verwenden und den Nutzungsbedingungen zustimmen zu können.
                <br/>
                <br/>
                Du trägst die alleinige Verantwortung für alle Aktivitäten, die über deinen audory-Account erfolgen. Deshalb solltest du es durch den Zugriff Dritter angemessen schützen. Dies gilt für den Zugriff auf deinen audory-Account selbst, d. h. die Zugangsdaten (E-Mail und Passwort), sowie den Zugriff auf deinen Computer oder deine mobilen Endgeräte.
                
              </div>
              <h2>3. audory-Dienste und deren Funktionen</h2>
              <div>
                Die audory-Dienste bestehen im Wesentlichen aus den Funktionen „Hören“ und „Editieren“, die wir dir im Folgenden erläutern:
              </div>
              <h3>„Hörer“ und „Bibliothek“</h3>
              <div>
              Um die interaktiven Hörbücher über audory zu hören, benötigst du zunächst die audory-App, die du über den offiziellen Google Play Store oder den Apple App Store herunterladen kannst. Dann legst du dir dein audory-Account an.
                <br />
                <br />
                Nach der Registrierung und Anmeldung gelangst du in unseren Shop. Dort suchst du dir anhand des Covers, der Beschreibung, der Hörprobe und evtl. Bewertungen und Rezensionen anderer Nutzer dein interaktives Hörbuch heraus.
                <br />
                <br />
                Entscheidest du dich für den Kauf (oder das kostenlose Herunterladen), gelangst du nach der evtl. erforderlichen Zahlungsabwicklung auf die Bibliotheksseite der audory-App. In der Bibliothek wird die audory-Cloud mit deinen erworbenen Hörbüchern dargestellt. Mit einem Klick auf die Geschichte kannst du diese auf dein Endgerät heruntergeladen. Nach dem Download ist sie für dich offline immer und überall verfügbar.
                <br />
                <br />
                Hast du das Ende der Geschichte erreicht, gelangst du zu der Bewertungsseite der Geschichte und kannst dort – natürlich freiwillig – eine Bewertung abgeben und eine Rezension schreiben.
                <br />
                <br />
                Hast du die Geschichte beendet und löschst du sie von deinem Gerät, steht sie dir danach aber weiterhin in der Bibliothek bzw. der audory-Cloud zur Verfügung. Entscheidest du dich, deinen audory-Account zu löschen, wird deine audory-Cloud mit deinen Geschichten ebenfalls gelöscht.
              </div>
              <h3>„Editor“</h3>
              <div>
              Nachdem du deinen Account erstellt hast, kannst du die Editorsoftware nutzen.
                <br />
                <br />
                Im Editor kannst du ein Hörbuch-Projekt anlegen. In diesem erstellt du den Entscheidungsbaum für deine Geschichte. Anschließend formulierst du die Texte in den einzelnen Knotenpunkten aus.
                <br />
                <br />
                Sobald deine Texte fertig sind, kannst du sie sie in der Vorschau auf Fehler testen.  Verfügst du bereits über Testleser, die Feedback geben wollen, generiert der Editor automatisch eine Testleser-PDF, die das komplette Projekt enthält und wie ein Spielbuch “gespielt” werden kann.
                <br />
                <br />
                Anschließend geht es zur Vertonung. Dabei generiert der Editor automatisch eine PDF-Datei für Sprecher, in der genau steht, welche Texte wie vertont werden müssen. Du kannst deine Geschichte selbst sprechen (lassen) oder in unserer Datenbank einen Sprecher auswählen, der für einen festgelegten Preis die Geschichte für dich vertont.
                <br />
                <br />
                Nachdem der Vertonung und erfolgt der Upload an. Dabei fügst du in jeden Knoten die entsprechende Audiodatei ein.
                <br />
                <br />
                Nachdem das interaktive Hörbuch final eingepflegt wurde, kannst du in der Vorschau Alles noch einmal prüfen.
                <br />
                <br />
                Anschließend legst du den Titel, das Cover, eine Hörprobe und sonstige Shop-Daten fest (Metadaten).
                <br />
                <br />
                Der letzte Schritt ist die Veröffentlichung. In unserem Editor gibt es ein Feld “Veröffentlichung”, in dem nochmal Alles automatisch geprüft wird. Hier legst du fest, wer an deiner Geschichte mitgewirkt hat, wer Autor und wer Sprecher ist und trägst ggf. deren Kontaktdaten ein. Abschließend werden der Verkaufspreis sowie die Anteilsverteilung pro Verkauf festgelegt.
                <br />
                <br />
                Nach deiner Freigabe prüfen wir die Geschichte und alle deine Daten nach unseren internen Richtlinien. Entweder wird die Geschichte akzeptiert und für alle App-Nutzer nun online freigeschaltet oder wir schicken dir ein Feedback mit den erforderlichen Anpassungen. In beiden Fällen wirst du über jedes Statusupdate per E-Mail benachrichtigt. 
                <br />
                <br />
                Mit deiner Freigabe räumst du uns die für das Bereitstellen der audory-Dienste die erforderlichen und von dir festgelegten Nutzungsrechte an dem interaktiven Hörbuch ein. Wir sind dabei unter anderem berechtigt, das interaktive Hörbuch und sonstige Beiträge zu löschen, zu bearbeiten und innerhalb der Plattform/audory-Dienste zu verschieben, um diese mit anderen Inhalten zu verknüpfen. Je nach Umfang der Rechteeinräumung für uns variiert deine Anteilsvergütung pro Verkauf.
                <br />
                <br />
                Du kannst die Löschung sämtlicher von dir bereitgestellten Inhalte von der Plattform jederzeit uns gegenüber beantragen.
              </div>
              <h2>4. Individuelle Empfehlungen</h2>
              <div>
              Teil der audory-Dienste ist die persönliche Empfehlung interaktiver Hörbücher.
                <br />
                <br />
                Was hast du davon?
                <br />
                <ol>
                  <li>Hörbücher, die zu dir passen</li>
                  <li>Weniger Fehlkäufe</li>
                  <li>Individuelle Angebote im Shop</li>
                </ol>
                <br />
                Du bekommst auf dich zugeschnittene Hörbücher vorgeschlagen, die dir mit hoher Wahrscheinlichkeit gefallen werden. Wir wollen Fehlkäufe vermeiden, weil sie langfristig niemandem nutzen. Deine Daten werden ausschließlich für dich verwendet und niemals an Dritte verkauft oder für Werbung genutzt. Du behältst zu jedem Zeitpunkt die Kontrolle.
                <br />
                <h3>Was wird über dich gespeichert?</h3>
                <br/>
                Immer wenn du eine Entscheidung triffst, speichern wir diese ab. Wir nutzen weder deinen Standort, noch deine Kamera oder dein Mikrofon.
                <h3>Wie verarbeiten wir deine Daten?</h3>
                <br/>
                Unser Algorithmus berechnet auf Grundlage deiner Entscheidungen, welche neuen interaktiven Hörbücher dir gefallen könnten und filtert diese für dich heraus.  Dabei schaut sich keine natürliche Person, sondern ausschließlich unser Programm deine Entscheidungen an. Um den Algorithmus zu verbessern, hat unser Entwicklerteam die Möglichkeit, diese Daten einzusehen. Hierbei werden deine Daten unter Berücksichtigung des geltenden Datenschutzrechtes und unserer Sicherheitsstandards verarbeitet.
                <br/>
                <br/>
                <center><h2>Es ist deine Entscheidung!</h2></center>
                <br/>
                Wir zwingen dich nicht dazu, uns deine Daten zu geben. Du entscheidest zu jedem Zeitpunkt selbst, ob du individuelle Empfehlungen von uns haben möchtest oder nicht.
              </div>
              <h2>5. Nutzerpflichten und Haftungsfreistellung</h2>
              <div>
                Unseren Nutzern ist es untersagt, Inhalte (z. B. durch Links oder Frames) auf unseren Plattformen (Website audory.io, audory-App und Editor) einzustellen oder einzubinden, die gegen gesetzliche Vorschriften, behördliche Anordnungen oder gegen die guten Sitten verstoßen. 
                <br/>
                <br/>
                Daneben ist es unseren Nutzern untersagt, Inhalte einzustellen oder einzubinden, die Rechte Dritter, insbesondere Urheber-, Marken- oder sonstige Schutzrechte, Persönlichkeitsrechte oder sonstige Rechte verletzen.
                <br/>
                <br/>
                Wir machen uns fremde Inhalte unter keinen Umständen zu Eigen. Der Nutzer garantiert uns gegenüber und gegenüber unseren übrigen Nutzern, dass die von ihm in dem Editor eingestellten interaktiven Hörbücher und sonstigen Inhalte keine Rechte Dritter oder Betriebsgeheimnisse verletzen.
                <br/>
                <br/>
                Wir behalten uns vor, fremde Inhalte zu sperren und zu löschen, wenn diese nach den geltenden Gesetzen strafbar sind oder erkennbar zur Vorbereitung strafbarer Handlungen dienen.
                <br/>
                <br/>
                Der Nutzer wird uns von sämtlichen Ansprüchen freistellen, die Dritte gegen uns wegen der Verletzung ihrer Rechte oder wegen Rechtsverstößen aufgrund der vom Nutzer eingestellten Inhalte geltend machen, sofern der Nutzer diese zu vertreten hat. Der Nutzer übernimmt diesbezüglich auch die Kosten unserer Rechtsverteidigung einschließlich sämtlicher Gerichts- und Anwaltskosten.
              </div>
              <h2>6. Urheberrecht sowie Nutzung der audory-Dienste und Inhalte</h2>
              <div>
                Sämtliche Texte, Bilder und andere auf unseren Plattformen (Website/audory-App) veröffentlichten Inhalte, Informationen und Daten unterliegen - sofern nicht anders gekennzeichnet - dem Urheberrecht von audory oder des jeweiligen Urhebers.
                <br/>
                <br/>
                Vorbehaltlich der Wahrung unsere Nutzungsbedingungen und ggf. der <a style={{color: PRIMARY_COLOR}} href='/cos'>Allgemeinen Verkaufsbedingungen</a> räumen wir oder der jeweilige Rechteinhaber dir ein nicht ausschließliches, nicht übertragbares, räumlich und zeitlich uneingeschränktes Recht für den Zugriff auf die audory-Dienste und dessen Inhalte sowie deren persönliche, nicht-gewerbliche Nutzung ein. 
                <br/>
                <br/>
                Alle Rechte, die dir nicht ausdrücklich auf Grundlage dieser Nutzungsbedingungen oder unseren <a style={{color: PRIMARY_COLOR}} href='/cos'>Allgemeinen Verkaufsbedingungen</a> übertragen werden, verbleiben bei uns bzw. den jeweiligen Rechteinhabern. Die audory-Dienste und Inhalte dürfen weder ganz noch in Teilen ohne unsere vorherige ausdrückliche schriftliche Zustimmung reproduziert, vervielfältigt, kopiert, verkauft, weiterverkauft oder anderweitig zu kommerziellen Zwecken genutzt werden.
              </div>
              <h2>7. Kinder- und Jugendschutz</h2>
              <div>
              Wir verfolgen einen klaren Grundsatz: Wir wollen sicherstellen, dass Alt und Jung ihren Spaß an interaktiven Hörbüchern haben.
              <br/>
              <br/>
              Interaktive Hörbücher zählen wie Hörbücher und Bücher zu Medien, die keiner Altersfreigabe unterliegen, wie man es von Filmen (FSK) oder Videospielen (USK) kennt. Trotzdem möchten wir mit gutem Beispiel vorangehen und kennzeichnen alle interaktiven Hörbücher auf audory mit einer Altersempfehlung, an der sich die Nutzer orientieren können.
              <br/>
              <h3>Für welche Altersklassen ist das interaktive Hörbuch geeignet?</h3>
              <br/>
              Damit du entscheiden kannst, was dein Kind hören darf und was nicht, findest du zu jeder unserer interaktiven Geschichten eine Altersempfehlung. Hierbei handelt es sich nicht um eine Altersfreigabe, sondern eine Empfehlung von unserer Seite.
              <br/>
              <h3>Was heißt das genau?</h3>
              <br/>
              Unsere Altersempfehlung bedeutet, dass wir die Inhalte dieser Geschichte für das angegebene Alter als geeignet einschätzen. Auf welchen Kriterien unsere Altersempfehlungen basieren, haben wir deshalb hier genau aufgeschlüsselt:
              <br/>
              <br/>
              <center>
              <b>Ab 0 Jahren</b><br/>	Für alle Altersklassen geeignet.
              <br/>
              <br/>
              <b>Ab 6 Jahren</b><br/>
              Die Geschichten dürfen Spannung und eine gewisse Dramatik enthalten. Ein positives oder zumindest harmonisches Ende ist vorhanden.
              <br/><br/>

              <b>Ab 9 Jahren</b><br/>

              Fiktionale Inhalte (Drachen, Hexen, Geister, Vampire, Werwölfe, …) können vorhanden sein.
              <br/><br/>

              <b>Ab 12 Jahren</b><br/>

              Seriöse Auseinandersetzung mit gesellschaftlichen Themen, wie Rassismus, Sprache, künstliche Intelligenz, Klimawandel, Umweltschutz und Drogen.
              <br/><br/>
              <b>Ab 14 Jahren</b><br/>

              Irgendeine Form von Gewalt ist vorhanden. Dazu zählt zum Beispiel gegen den Willen festgehalten zu werden, Schlagen, aber auch psychische Gewalt (verängstigen o.ä.).
              <br/><br/>
              <b>Ab 16 Jahren</b><br/>

              Mutwillige Verletzungen/Ermordung mit Blut oder sexuelle Handlungen vorhanden.
              <br/><br/>
              <b>Ab 18 Jahren</b><br/>

              Inhalte wie sexuelle Handlungen, Verletzungen, Gewalt etc. werden explizit beschrieben.
              </center>
              <br/>
              <h3>
              Verstoß gefunden?
              </h3>
              <br/>
              Ist dir eine Geschichte begegnet, deren Inhalte nicht zu unserer Altersempfehlung passen? Melde dich bei uns. Wir sind jederzeit bemüht, unsere Inhalte für jeden optimal zu gestalten. Unsere wunderbaren Kinder zählen selbstverständlich dazu.
              </div>
              <h2>8. Haftung von audory</h2>
              <div>
                Wir haften für Vorsatz und grobe Fahrlässigkeit uneingeschränkt, für leichte Fahrlässigkeit jedoch nur bei der Verletzung vertragswesentlicher Pflichten. Die Haftung bei Verletzung einer solchen vertragswesentlichen Pflicht ist auf den vertragstypischen Schaden begrenzt, mit dessen Entstehen wir bei Vertragsabschluss aufgrund der zu diesem Zeitpunkt bekannten Umstände rechnen mussten.
                <br/>
                <br/>
                Für von uns nicht verschuldete Störungen innerhalb des Leitungsnetzes übernehmen wir keine Haftung.
                <br/>
                <br/>
                Für den Verlust von Daten haften wir nach Maßgabe der vorstehenden Absätze nur dann, wenn ein solcher Verlust durch angemessene Datensicherungsmaßnahmen seitens des Nutzers nicht vermeidbar gewesen wäre.
              </div>
              <h2>9. Vertragsdauer</h2>
              <div>
                Nach der Registrierung besteht unser Vertragsverhältnis auf unbestimmte Zeit.
                <br/>
                <br/>
                Du kannst deinen audory-Account jederzeit kündigen. Hast du interaktive Hörbücher als Autor veröffentlicht, müssen diese zunächst aus den audory-Diensten entfernt werden.
                <br/>
                <br/>
                Wir sind zur außerordentlichen Kündigung berechtigt, wenn wir schwerwiegende Verstöße, insbesondere solche nach Ziff. 5, über deinen audory-Account feststellen.  
              </div>
              <h2>10. Sonstige Bestimmungen</h2>
              <div>
                Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. 
                <br/>
                <br/>
                Sollten einzelne Bestimmungen dieser Nutzungsbedingungen unwirksam sein oder werden und/oder den gesetzlichen Regelungen widersprechen, so wird hierdurch die Wirksamkeit der Nutzungsbedingungen im Übrigen nicht berührt. Die unwirksame Bestimmung wird einvernehmlich durch eine solche Bestimmung ersetzt, welche dem wirtschaftlichen Zweck der unwirksamen Bestimmung in rechtswirksamer Weise am nächsten kommt. Die vorstehende Regelung gilt entsprechend bei Regelungslücken.
                <br/>
                <br/>
                Wir behalten uns vor, diese Nutzungsbedingungen zu ändern, wenn dies aus sachlichen Gründen (z. B. Äderung der audory-Dienste, der Gesetzeslage oder der Rechtsprechung) erforderlich erscheint. Wenn wir die Nutzungsbedingungen in wesentlichen Punkten ändern wollen, setzen wir dich über die zu erwartenden Änderungen angemessen in Kenntnis. Du kannst den Änderungen der Nutzungsbedingungen innerhalb von 14 Tagen nach unserer Information widersprechen. Machst du hiervon keinen Gebrauch, gelten die Änderungen als genehmigt und die neue Fassung der Nutzungsbedingungen als akzeptiert.
                <br/>
                <br/>
                Sollten einzelne Bestimmungen dieser Nutzungsbedingungen unwirksam sein oder werden, so bleibt die Wirksamkeit der übrigen Bestimmungen hiervon unberührt. Die unwirksame oder nichtige Bestimmung wird durch eine Regelung ersetzt, die dem wirtschaftlichen Zweck der unwirksamen oder nichtigen Bestimmung in wirksamer Weise am nächsten kommt.
                <br/>
                <br/>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung bereit, die du unter <a href='https://ec.europa.eu/consumers/odr'>https://ec.europa.eu/consumers/odr</a> findest. Wir bevorzugen es, dein Anliegen im direkten Austausch zu klären und nehmen deshalb nicht an Verbraucherschlichtungsverfahren teil. Bitte kontaktiere uns bei Fragen, Problemen oder Hinweisen zu den audory-Diensten direkt unter
                <br/>
                <br/>
                <br/>
                <b>audory UG (haftungsbeschränkt)</b><br/>
                Technologie-Campus 1,<br/>
                09126 Chemnitz<br/>
                <hr/>
                <b>Vertretungsberechtigter Geschäftsführer</b><br/>
                Max Rose<br/>
                E-Mail: max.rose@audory.io<br/>
                Telefon: +49 1577 3064495
              </div>
            </div>
          </div>
        </Container>
      </Segment>
    );
  }
}

export default TOS;



// WEBPACK FOOTER //
// ./src/components/TOS/TOS.js